import { CALL_API } from 'redux-api-middleware';
import { baseUrl } from '../config';

import { createRequestTypes } from './utils';

export const LOADING = '@@cryptocurrencies/LOADING';
export const CHANGE_FILTERS = '@@cryptocurrencies/CHANGE_FILTERS';

export const FETCH_DATA = createRequestTypes('@@cryptocurrencies/FETCH_DATA');
export const FETCH_SELECTED_DATA = createRequestTypes('@@cryptocurrencies/FETCH_SELECTED_DATA');
export const FETCH_GLOBAL_DATA = createRequestTypes('@@cryptocurrencies/FETCH_GLOBAL_DATA');

// @TODO Add ?convert=NOK ? Its supported by coinmarketcap API
export const fetchSelectedCryptocurrencies = () => ({
    [CALL_API]: {
        endpoint: `${baseUrl}/cryptocurrencies/selected`,
        method: 'GET',
        types: [
            { type: FETCH_SELECTED_DATA.REQUEST },
            {
                type: FETCH_SELECTED_DATA.SUCCESS,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json();
                    }
                    return null;
                },
            },
            { type: FETCH_SELECTED_DATA.FAILURE },
        ],
    },
});

export const fetchCryptocurrencies = () => ({
    [CALL_API]: {
        endpoint: `${baseUrl}/cryptocurrencies`,
        method: 'GET',
        types: [
            { type: FETCH_DATA.REQUEST },
            {
                type: FETCH_DATA.SUCCESS,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json();
                    }
                    return null;
                },
            },
            { type: FETCH_DATA.FAILURE },
        ],
    },
});

export const fetchCryptocurrenciesGlobalData = () => ({
    [CALL_API]: {
        endpoint: `${baseUrl}/cryptocurrencies/global`,
        method: 'GET',
        types: [
            { type: FETCH_GLOBAL_DATA.REQUEST },
            {
                type: FETCH_GLOBAL_DATA.SUCCESS,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json();
                    }
                    return null;
                },
            },
            { type: FETCH_GLOBAL_DATA.FAILURE },
        ],
    },
});

export function loadingCryptocurrencies() {
    return { type: LOADING };
}

export function changeCryptocurrenciesFilters(filters) {
    return { type: CHANGE_FILTERS, filters };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/cryptocurrencies.js
 **/